// extracted by mini-css-extract-plugin
export default {"carouselContainer":"style_carouselContainer__C2rkQ"};